module.exports = __webpack_public_path__ + "media/images/help/line/bg-diagonal-0da2ba8354f84bc2cf6f6dfcebf526ca.png";